import { useState, useEffect } from "react";
import styled from "styled-components";
import { Image, ImageWithText } from "../models/post";
import { DeleteButton } from "./text-component";
import ImageAlignment from "../models/image-alignment";
//@ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
//@ts-ignore
import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import ChangeImageModal from "./change-image-modal";
import TextInput from "../components/text-input";
import { CloseRounded, SwapHorizRounded } from "@mui/icons-material";

const Grid = styled.div`
	display: grid;
	grid-template-columns: ${({ alignment }: { alignment: ImageAlignment; }) => alignment === "left" ? "8fr 1fr 12fr" : "12fr 1fr 8fr"};
`;
const ImageStyle = styled.div`
	border-radius: 12px;
	border: 1px solid #EEEEEE;
	overflow: hidden;
	cursor: pointer;
	margin-bottom: .5rem;
	&:hover {
		border: 1px solid #c8c8c8;
	}
	img {
		width: 100%;
		object-fit: cover;
		vertical-align: middle;
	}
`;

const Center = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
const SwitchButton = styled.div`
	width: 30px;
	height: 30px;
	border-radius: 50%;
	font-size: 1.2rem;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background: #EEEEEE;
	}
`;

export function ImageTextComponent(props: {
	imageWithText: ImageWithText;
	update: (image: Image, text: string, alignment: ImageAlignment) => void;
	deleteContent: () => void;
}) {

	const [src, setSrc] = useState(props.imageWithText.image.src);
	const [alt, setAlt] = useState(props.imageWithText.image.alt);
	const [link, setLink] = useState(props.imageWithText.image.link);
	const [text, setText] = useState(props.imageWithText.text);
	const [alignment, setAlignment] = useState(props.imageWithText.alignment);

	const [showDelete, setShowDelete] = useState(false);
	const onChange = (_event: any, editor: { getData: any; }) => {
		setText(editor.getData());
	};

	const switchAlignment = () => {
		setAlignment(a => a === "left" ? "right" : "left");
	};

	const [showModal, setShowModal] = useState(false);

	const image = <div>
		<ImageStyle onClick={() => setShowModal(true)}>
			<img src={src} alt={alt} />
		</ImageStyle>
		<TextInput value={alt} onChange={e => setAlt(e.target.value)} placeholder="Bildbeschreibung" />
		<div style={{ marginTop: "0.5rem" }}>
			<TextInput value={link} onChange={e => setLink(e.target.value)} placeholder="Link" />
		</div>
	</div>;

	const editor = <div>
		<div onMouseMove={() => setShowDelete(true)} onMouseEnter={() => setShowDelete(true)} onMouseLeave={() => setShowDelete(false)} style={{
			position: "relative"
		}}>
			<CKEditor editor={BalloonEditor} data={text} config={{
				toolbar: ['heading', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
				placeholder: "Text schreiben..."
			}} onChange={onChange} />
			<DeleteButton show={showDelete} onClick={props.deleteContent}>
				<CloseRounded />
			</DeleteButton>
			{showModal && <ChangeImageModal close={() => setShowModal(false)} updateImage={(src: string) => setSrc(src)} />}
		</div>
	</div>;

	useEffect(() => {
		props.update({ src, alt, info: "", link }, text, alignment);
	}, [src, alt, text, alignment, props, link]);

	return <Grid alignment={alignment}>
		{alignment === "left" ? image : editor}
		<Center>
			<SwitchButton onClick={switchAlignment}>
				<SwapHorizRounded />
			</SwitchButton>
		</Center>
		{alignment === "left" ? editor : image}
	</Grid>;
}
